// react
import { createContext, useContext } from 'react';

export interface ContainerLayoutContextValue {
  /** When true, page-level `PageContainer`s render at full width instead of `xl`. */
  fullWidth: boolean;
  toggleFullWidth: () => void;
}

export const ContainerLayoutContext = createContext<
  ContainerLayoutContextValue | undefined
>(undefined);

export function useContainerLayout() {
  const context = useContext(ContainerLayoutContext);

  if (!context) {
    throw new Error(
      'useContainerLayout must be used within ContainerLayoutProvider',
    );
  }

  return context;
}
